import React, { useState, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/website/Header';
import Footer from './components/website/Footer';
import Loader from './components/website/Loader';
import AdminRouter from './adminRouter';
import AppRoutes from './appRouter';
import { useAuth } from './context/AuthContext';
import ScrollToTop from './components/website/ScrollToTop';

function App() {
  const [initialLoading, setInitialLoading] = useState(true);
  const { currentUser, loading: authLoading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const isAdminRoute = location.pathname.startsWith('/admin');

  if (initialLoading || authLoading) {
    return <Loader />;
  }

  return (
    <div className="App">
      {!isAdminRoute && <Header />}
      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/*" element={<AppRoutes />} />
          {currentUser && <Route path="/admin/*" element={<AdminRouter />} />}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
    </div>
  );
}

export default App;